"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LogObjToStrCanvas = void 0;
var log_1 = require("../../../../../core/rich-utils/debug/logger/base-logger/log");
var log_obj_to_str_1 = require("../../../../../core/rich-utils/debug/logger/base-logger/log-obj-to-str");
var log_obj_to_str_layout_1 = require("../../../../../core/rich-utils/debug/logger/layout-logger/log-obj-to-str-layout");
var key_1 = require("@devexpress/utils/lib/utils/key");
var event_manager_1 = require("../../../../event-manager");
var mouse_event_source_1 = require("../../../../mouse-handler/mouse-event-source");
var LogObjToStrCanvas = (function () {
    function LogObjToStrCanvas() {
    }
    LogObjToStrCanvas.richMouseEvent = function (evt) {
        var result = [];
        result.push("absPoint: " + log_obj_to_str_1.LogObjToStr.point(evt.absolutePoint));
        result.push("scroll: " + log_obj_to_str_1.LogObjToStr.point(evt.scroll));
        result.push("layoutPoint: " + log_obj_to_str_layout_1.LogObjToStrLayout.layoutPoint(evt.layoutPoint));
        result.push("modifiers: " + log_1.Log.mask(key_1.ModifierKey, evt.modifiers, key_1.ModifierKey.None));
        result.push("button: " + log_1.Log.mask(event_manager_1.MouseButton, evt.button, event_manager_1.MouseButton.None));
        result.push("middleButtonPressed: " + evt.middleButtonPressed);
        result.push("mouseEvent: " + evt.mouseEvent);
        result.push("source: " + mouse_event_source_1.MouseEventSource[evt.source]);
        return result.join("\n");
    };
    return LogObjToStrCanvas;
}());
exports.LogObjToStrCanvas = LogObjToStrCanvas;
